// extracted by mini-css-extract-plugin
module.exports = {"footer":"CarouselTabCars_footer__UFtz6","footerBanner":"CarouselTabCars_footerBanner__hiVwi","footerBannerContent":"CarouselTabCars_footerBannerContent__FT3Lp"};